function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 14.666h-.229a2.334 2.334 0 00-2.104-1.333c-.928 0-1.729.546-2.104 1.332l-3.125.001a2.334 2.334 0 00-2.105-1.333c-.928 0-1.73.547-2.105 1.334H6V7.333h7.333v4L14 12h4v2.666zm-2.333 2a1 1 0 110-2 1 1 0 010 2zm-7.334 0a1.001 1.001 0 010-2 1 1 0 010 2zm8-8l1.5 2h-3.166v-2h1.666zM17 7.334h-2.333v-.666L14 6H5.333l-.666.667v8.668l.667.666h.693A2.334 2.334 0 008.333 18a2.334 2.334 0 002.307-2l2.72-.002A2.333 2.333 0 0015.667 18a2.334 2.334 0 002.306-2l.694-.001.666-.667v-4.888L17 7.334z",
  fillRule: "evenodd"
});

const SvgDeliveryTruck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24
}, props), _ref);

export default SvgDeliveryTruck;